import { render, staticRenderFns } from "./CourseResourceCreate.vue?vue&type=template&id=87096f76&scoped=true&"
import script from "./CourseResourceCreate.vue?vue&type=script&lang=js&"
export * from "./CourseResourceCreate.vue?vue&type=script&lang=js&"
import style0 from "./CourseResourceCreate.vue?vue&type=style&index=0&id=87096f76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87096f76",
  null
  
)

export default component.exports